import { create } from 'zustand'

const useDarkModeStore = create(set => ({
    isDarkMode: false,

    initialize: () => {
        if (typeof window === 'undefined') return

        const saved = localStorage.getItem('darkMode')
        const value =
            saved !== null
                ? JSON.parse(saved)
                : window.matchMedia('(prefers-color-scheme: dark)').matches

        // Apply to DOM
        document.documentElement.classList.toggle('dark', value)

        // Update Zustand state
        set({ isDarkMode: value })
    },

    toggleDarkMode: () =>
        set(state => {
            if (typeof window === 'undefined') return state

            const newMode = !state.isDarkMode

            console.log('toggleDarkMode → newMode:', newMode)

            document.documentElement.classList.toggle('dark', newMode)
            localStorage.setItem('darkMode', JSON.stringify(newMode))
            return { isDarkMode: newMode }
        }),

    setDarkMode: value => {
        if (typeof window === 'undefined') return

        document.documentElement.classList.toggle('dark', value)
        localStorage.setItem('darkMode', JSON.stringify(value))
        set({ isDarkMode: value })
    },
}))

export default useDarkModeStore
